import {
  BarChart3, Calendar, CalendarDays, CalendarRange, ClipboardList, DollarSign, LayoutGrid, ListChecks,
  Megaphone, PackageSearch, Scale, ShoppingCart, Target, Truck, Warehouse, type LucideIcon,
} from "lucide-react"
import type { Scope } from "../Sidebar/sidebarData"

export type NavPage = {
  key: string
  label: string
  icon: LucideIcon
  scope: Scope
  blurb: string
  // Only shown when the picked market has a wholesale channel (or none is picked).
  wholesaleOnly?: boolean
}

export type NavGroup = {
  heading: string
  // Planning, Purchase and Push: their own column with a large heading.
  main?: LucideIcon
  // One line under a main heading: what this part of Atlas is for.
  blurb?: string
  // Each page stands alone: no tabs between them in the page title row.
  noTabs?: boolean
  pages: NavPage[]
}

// The live sidebar's links (components/layout/navLinks.ts), grouped the same
// way. Admin pages stay out of the menu. Groups without `main` stack in the
// menu's first column, in this order.
export const GROUPS: NavGroup[] = [
  {
    heading: "",
    noTabs: true,
    pages: [
      { key: "home", label: "Home", icon: LayoutGrid, scope: "either", blurb: "How the business is doing." },
      { key: "my-work", label: "My Work", icon: ListChecks, scope: "none", blurb: "Your tasks." },
    ],
  },
  {
    heading: "Planning", main: Target, blurb: "Sales targets and forecasts for each market.",
    pages: [
      { key: "top-down", label: "Top Down", icon: Target, scope: "market", blurb: "Revenue targets split across channels and months." },
      { key: "pricings", label: "Products & Pricings", icon: DollarSign, scope: "market", blurb: "Planned prices per product and channel." },
      { key: "by-month", label: "By Month", icon: CalendarDays, scope: "market", blurb: "Units per product and month." },
      { key: "by-day", label: "By Day", icon: Calendar, scope: "market", blurb: "Units per product and day." },
      { key: "wholesale-forecast", label: "Wholesale Forecast", icon: CalendarRange, scope: "market", blurb: "Wholesale units per account and month.", wholesaleOnly: true },
    ],
  },
  {
    heading: "Purchase", main: ShoppingCart, blurb: "What to buy, and what is on its way.",
    pages: [
      { key: "purchase-plan", label: "Purchase Plan", icon: ClipboardList, scope: "all", blurb: "The products being bought, all markets." },
      { key: "incoming", label: "Incoming / PO", icon: Truck, scope: "all", blurb: "Purchase orders and stock on its way." },
    ],
  },
  {
    heading: "Push", main: Megaphone, blurb: "Products with too much stock.",
    pages: [
      { key: "push-review", label: "Review", icon: PackageSearch, scope: "market", blurb: "Overstocked products and what to do about them." },
    ],
  },
  {
    heading: "Inventory",
    pages: [
      { key: "inventory-overview", label: "Inventory Overview", icon: Warehouse, scope: "either", blurb: "Stock per warehouse and when it runs out." },
    ],
  },
  {
    heading: "Performance",
    pages: [
      { key: "revenue", label: "Revenue", icon: BarChart3, scope: "either", blurb: "What actually sold." },
      { key: "plan-vs-actual", label: "Plan vs Actual", icon: Scale, scope: "market", blurb: "What sold against what was planned." },
    ],
  },
]
